// extracted by mini-css-extract-plugin
module.exports = {"red":"Monitor_red_z8nPC"};